import type { Post } from '../../api/posts';
import { Alert } from '../ui';

/**
 * What a moderator decided about this story, for the person who wrote it.
 *
 * Only ever shown to the author — the backend returns `moderation: null` to
 * everybody else, and a story rejected once should not carry that around in
 * public for the rest of its life.
 *
 * The reason is shown in full rather than summarised, because it is the only
 * part of a decision an author can do anything with. And the moderator is not
 * named: what was decided and why is the author's business; who decided it
 * turns a policy into a grudge.
 */
export function ModerationNotice({ post }: { post: Post }) {
  const note = post.moderation;
  if (!note) {
    return null;
  }

  if (post.status === 'REJECTED' && note.decision === 'REJECTED') {
    return (
      <Alert tone="warning" title={`Version ${note.version} was not approved`}>
        <p>{note.reason}</p>
        <p>Change it and send it back when you are ready.</p>
      </Alert>
    );
  }

  if (post.status === 'HIDDEN' && note.decision === 'HIDDEN') {
    return (
      <Alert tone="warning" title="A moderator has taken this story down">
        <p>{note.reason}</p>
        <p>You can still read it here. Nobody else can.</p>
      </Alert>
    );
  }

  return null;
}
